import React from "react";
import { AdministrationRoutes } from "./AdministrationRoutes";

export const Administration = () => {
  return (
    <>
      <AdministrationRoutes></AdministrationRoutes>
    </>
  );
};
